import axios from 'axios';

const colourSelect = document.querySelector('select[name="variantColour"]'),
    sizeSelect = document.querySelector('select[name="variantSize"]'),
    variantSelect = document.querySelector('select[name="purchasableId"]');

export function cart() {
    /**
     * Quantity Triggers
     */ 
    const quantity = {
        subtract: document.querySelectorAll('.js-quantity-subtract'),
        add: document.querySelectorAll('.js-quantity-add')
    },
    removeItem = document.querySelectorAll('.js-remove-item');

    // -1 from quantity field
    quantity.subtract.forEach(el =>{
        el.addEventListener('click', () => {
            let input = el.closest('.js-quantity').querySelector('input'),
                currentVal = parseInt(input.value, 10);

            input.value = (currentVal - 1 < 0 ? 0 : currentVal - 1 );
        });
    });

    // +1 to quantity field
    quantity.add.forEach(el => {
        el.addEventListener('click', () => {
            let input = el.closest('.js-quantity').querySelector('input'),
                currentVal = parseInt(input.value, 10);
                
            input.value = currentVal + 1;
        });
    });

    // Fade Back cart item if set to be removed
    removeItem.forEach(el => {
        el.addEventListener('click', (e) => {
            if (e.target.tagName !== 'INPUT' ) {
                el.closest('.js-cart-item').classList.toggle('removed');
            }
        });
    });
}

export function product() {
    /**
     * Quantity Triggers
     */ 
    const quantity = {
            input: document.querySelector('.js-quantity-input'),
            subtract: document.querySelector('.js-quantity-subtract'),
            add: document.querySelector('.js-quantity-add')
        },
        primaryImageList = document.querySelector('.js-product-primary-images'),
        imageThumbs = document.querySelector('.js-product-image-thumbs'),
        imageThumbItems = document.querySelectorAll('.js-product-image-thumb');

    if (quantity.subtract) {
        // -1 from quantity field
        quantity.subtract.addEventListener('click', () => {
            let currentVal = parseInt(quantity.input.value, 10);
            
            quantity.input.value = (currentVal - 1 < 0 ? 0 : currentVal - 1 );
        });
    }
    
    if (quantity.add) {
        // +1 to quantity field
        quantity.add.addEventListener('click', () => {
            let currentVal = parseInt(quantity.input.value, 10);

            quantity.input.value = currentVal + 1;
        });
    }

    /**
     * Image Gallery
     */ 
    imageThumbItems.forEach(el => {
        el.addEventListener('click', () => {
            const index = el.dataset.index;

            // Remove .active class from thumb
            imageThumbs.querySelector('.active').classList.remove('active');

            // Add .active to class to clicked thumb
            el.classList.add('active');

            // Remove .active class from primary image
            primaryImageList.querySelector('.active').classList.remove('active');

            // Find primary image with same index as thumb and add .active class
            primaryImageList.querySelector(`li[data-index='${index}']`).classList.add('active');
        });
    });

    /**
     * Variant Selections
     */
    // If the colour select exists, add an on change handler to it
    if (colourSelect) {
        colourSelect.addEventListener('change', function(e) {
            updateSelectStatus('colour');
        });
    }

    // If the size select exists, add an on change handler to it
    if (sizeSelect) {
        sizeSelect.addEventListener('change', function(e) {
            updateSelectStatus('size');
        });
    }

    // Disable the colours and sizes that are completely sold out 
    disableSoldOutOptions();
}

export function checkout() {
    const shippingAddressSameAsBilling = document.querySelectorAll('input[name="shippingAddressSameAsBilling"]'),
        shippingAddress = document.querySelector('.js-shipping-address');

    shippingAddressSameAsBilling.forEach(input => {
        input.addEventListener('change', () => {
            if (document.querySelector('input[name="shippingAddressSameAsBilling"]:checked').value === '1') {
                // Hide billing address fields
                shippingAddress.classList.add('hidden');
            } else {
                // Show billing address fields
                shippingAddress.classList.remove('hidden');
            }
        });
    });
}

export function getCartCount() {
    const cartCountEl = document.querySelector('.js-cart-count');

    // Request count
    axios.get('/ajax/cart-count').then(response => {
        const count = response.data;

        if (count) {
            cartCountEl.textContent = count;
            cartCountEl.classList.remove('hidden');
        }
    });
}

/**
 * Triggered when one of the attribute dropdowns is selected. 
 */
function updateSelectStatus(attribute) {
    if (colourSelect && sizeSelect) {
        if (attribute === 'colour') {
            disableUnavailableOptions('colour', colourSelect.value);
        } else if (attribute === 'size') {
            disableUnavailableOptions('size', sizeSelect.value);
        }

        selectVariant(colourSelect.value, sizeSelect.value);
    } else {
        if (attribute === 'colour') {
            selectVariant(colourSelect.value, '');
        } else {
            selectVariant('', sizeSelect.value);
        }
    }
}

/**
 * Selects a variant based on the value of the two attribute dropdowns
 */
function selectVariant(colour, size) {
    let variantOptions = variantSelect.querySelectorAll('option'),
        selectedOption = null;

    variantSelect.value = '';

    variantOptions.forEach(el => {
        if (String(el.dataset.colour) === colour && String(el.dataset.size) === size) {
            variantSelect.value = el.value;
            selectedOption = el;
        }
    });

    updatePrice(selectedOption);
}

/**
 * Based on the attribute and value the user selected, disable all options
 * in the other dropdown that don't have a variant with this value.
 */
function disableUnavailableOptions(attribute, val) {
    var variantOptions = variantSelect.querySelectorAll('option');
    var reverseAttribute = attribute === 'colour' ? 'size' : 'colour';

    if (attribute === 'colour') {
        sizeSelect.querySelectorAll('option:disabled').forEach(el => {
            el.disabled = false;
        });
    } else {
        colourSelect.querySelectorAll('option:disabled').forEach(el => {
            el.disabled = false;
        });
    }

    if (val !== '') {
        var available = [];

        variantOptions.forEach(el => {
            if (el.dataset[attribute] === val && !el.disabled) {
                available.push(el.dataset[reverseAttribute]);
            }
        });

        var otherSelect = attribute === 'colour' ? sizeSelect : colourSelect;

        otherSelect.querySelectorAll('option').forEach(el => {
            if (available.includes(el.value) || el.value === '') {
                el.disabled = false;
            } else {
                el.disabled = true;
            }
        });
    }

    disableSoldOutOptions();
}

/**
 * Disables sold out options. Loops over the two selects and checks if
 * there is a variant in the variants dropdown that is not out of stock.
 */
function disableSoldOutOptions() {
    if (! variantSelect) {
        return;
    }
    
    var variantOptions = variantSelect.querySelectorAll('option');

    if (colourSelect) {
        colourSelect.querySelectorAll('option').forEach(el => {
            let opt = el,
                found = false;

            variantOptions.forEach(el => {
                if (el.dataset.outofstock !== true && String(el.dataset.colour) === opt.value) {
                    found = true;
                }
            });

            if (!found) {
               opt.disabled = true;
            }
        });
    }

    if (sizeSelect) {
        sizeSelect.querySelectorAll('option').forEach(el => {
            let opt = el,
                found = false;

            variantOptions.forEach(el => {
                if (el.dataset.outofstock !== true && String(el.dataset.size) === opt.value) {
                    found = true;
                }
            });

            if (!found) {
                opt.disabled = true;
            }
        });
    }
}

/**
 * Updates the price based on the variant that was selected. You'll probably
 * want to do some currency formatting in here, and maybe remove the sale
 * price if it's the same as the full price.
 */
function updatePrice(option) {
    if (option !== null) {
        const priceFull = document.querySelector('[data-variant-price-full]'),
            priceSale = document.querySelector('[data-variant-price-sale]');

        if (priceFull) {
            priceFull.textContent = option.dataset.price;
            
            // Only show the original price if it doesn't equal the sale price
            if (option.dataset.price !== option.dataset.saleprice) {
                priceFull.classList.add('show');
            } else {
                priceFull.classList.remove('show');
            }
        }
        
        if (priceSale) {
            priceSale.textContent = option.dataset.saleprice;
        }
    }
}